module.exports = __webpack_public_path__ + "img/noImage.6d3db53e.jpg";